module.exports = __webpack_public_path__ + "img/MDI-certificate.78f630d2.svg";